import { IncumbentOption } from './getIncumbentOptions';

export const getIncumbentOptionLabel = (incumbentOptions: IncumbentOption[], value?: string | null): string => {
  const selected = incumbentOptions.find(option => String(option.value) === String(value));

  if (selected?.label?.length) {
    return selected.label;
  }
  return 'None';
};
